import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arvind-upadhye',
  templateUrl: './arvind-upadhye.component.html',
  styleUrls: ['./arvind-upadhye.component.scss']
})
export class ArvindUpadhyeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
